import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, Icon, Row, Col } from 'antd';
import { Panel } from 'components/ui/index';
import { setTeams, fetchTeams } from 'store/global/action';
import { Department, User } from '../component';
import {
  getUserFolderData,
  getAllUser,
  setSelectedTeam,
  setDepartmentVisible,
  setSelectedUser
} from '../../flow/action';
import { getTeamUsers, getSelectedTeamName } from '../../flow/reselect';


class EditView extends React.Component {
  componentDidMount() {
    const { getAllUser, fetchTeams } = this.props;
    fetchTeams();
    getAllUser();
  }

  render() {
    const {
      teams,
      setSelectedTeam,
      setTeams,
      teamUsers,
      getUserFolderData,
      selectedTeamName,
      isDepartmentVisible,
      setDepartmentVisible,
      setSelectedUser
    } = this.props;

    const actionsRight = (
      <div>
        <Button
          className="btn-ellipse email-theme-btn"
          size="small"
          onClick={() => setDepartmentVisible(!isDepartmentVisible)}
        >
          <Icon type="edit" />
          <FormattedMessage id="page.emailTemplates.hideDepartments" />
        </Button>
      </div>
    );

    return (
      <Panel
        panelTitle={<FormattedMessage id="page.emailTemplates.emailTemplates" />}
        panelClasses="email-theme-panel"
        contentClasses="pl-lg pr-lg"
        actionsRight={actionsRight}
      >
        {isDepartmentVisible &&
          <Row className="pt-lg pb-lg">
            <Col className="gutter-row field-label" span={12}>
              <Department
                teams={teams}
                setTeams={setTeams}
                setSelectedTeam={setSelectedTeam}
              />
            </Col>
            <Col className="gutter-row field-value" span={12}>
              <User
                teamUsers={teamUsers}
                getUserFolderData={getUserFolderData}
                selectedTeamName={selectedTeamName}
                setSelectedUser={setSelectedUser}
              />
            </Col>
          </Row>
        }
      </Panel>
    );
  }
}

const mapStateToProps = ({ global, setup, loginUser }) => {
  const { emailTemplates } = setup;
  return {
    lang: global.language,
    teams: global.settings.teams,
    teamUsers: getTeamUsers({ emailTemplates }),
    loginUser,
    isDepartmentVisible: emailTemplates.ui.isDepartmentVisible,
    newTeam: emailTemplates.newTeam,
    selectedTeamName: getSelectedTeamName({ global, emailTemplates }),
  };
};

const mapDispatchToProps = {
  setTeams,
  getUserFolderData,
  getAllUser,
  setSelectedTeam,
  setDepartmentVisible,
  setSelectedUser,
  fetchTeams
};

export default connect(mapStateToProps, mapDispatchToProps)(EditView);




// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/container/departmentView.jsx